// import _mergeJSXProps from '@vue/babel-helper-vue-jsx-merge-props'
import { createNamespace } from 'vant/lib/utils'
// import { inherit } from 'vant/lib/utils/functional'
// import { BORDER_BOTTOM } from 'vant/lib/utils/constant' // Types

var _createNamespace = createNamespace('sku-row')
var createComponent = _createNamespace[0]
var bem = _createNamespace[1]

function SkuRow (h, props, slots, ctx) {
    return h('div',  [h('div', {
        'class': bem('title')
    }, [props.skuRow.k]), slots.default && slots.default()])
}

SkuRow.props = {
    skuRow: Object
}
export default createComponent(SkuRow)
